import React from "react";
import { Container } from "react-bootstrap";
import './About.css';
import './Global.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const About = () => {

	const images = [
		/*{src: "../gallery/image1.jpg", alt: "Image One"},*/
		{src: "../gallery/image2.jpg", alt: "Image Two"},
		/*{src: "../gallery/image3.jpg", alt: "Image Three"},*/
		/*{src: "../gallery/image4.jpg", alt: "Image Four"},*/
		{src: "../gallery/image5.jpg", alt: "Image Five"},
		{src: "../gallery/image9.jpg", alt: "Image Nine"},
		{src: "../gallery/image6.jpg", alt: "Image Six"}, // selfie
		{src: "../gallery/image10.jpg", alt: "Image Ten"},
		{src: "../gallery/image11.jpg", alt: "Image Eleven"},
		{src: "../gallery/image12.jpg", alt: "Image Twelve"},
		{src: "../gallery/image8.jpg", alt: "Image Eight"}, // selfie
		{src: "../gallery/image13.jpg", alt: "Image Thirteen"},
		{src: "../gallery/image14.jpg", alt: "Image Fourteen"},
		{src: "../gallery/image15.jpg", alt: "Image Fifteen"},
		{src: "../gallery/image7.jpg", alt: "Image Seven"}, // selfie
		{src: "../gallery/image16.jpg", alt: "Image Sixteen"},
		{src: "../gallery/image17.jpg", alt: "Image Seventeen"},
		{src: "../gallery/image18.jpg", alt: "Image Eighteen"},
		{src: "../gallery/image19.jpg", alt: "Image Nineteen"}, // selfie
		{src: "../gallery/image20.jpg", alt: "Image Twenty"},
		{src: "../gallery/image21.jpg", alt: "Image Twenty-One"},
		{src: "../gallery/image22.jpg", alt: "Image Twenty-One"},
		{src: "../gallery/image26.jpg", alt: "Image Twenty-One"},
		{src: "../gallery/image27.jpg", alt: "Image Twenty-One"},
		{src: "../gallery/image28.jpg", alt: "Image Twenty-One"}
	];


	return (
		<div class="about text-center container-styling">
			<Container fluid className="g-0 top-header">
				<h1 class="text-center title-padding">Rebecca & Nathan</h1>

				<div id="myCarousel" class="carousel slide mb-6" data-bs-ride="carousel">
					<div class="carousel-inner">
						{images.map((image, index) => (
							<div class={`carousel-item ${index === 0 ? 'active' : ''}`}>
								<img class="image-frame" src={image.src} alt={image.alt} /> 
							</div>
						))
						}
					</div>
					<button class="carousel-control-prev front" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
					<span class="carousel-control-prev-icon" aria-hidden="true"></span>
					<span class="visually-hidden">Previous</span>
					</button>
					<button class="carousel-control-next front" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
					<span class="carousel-control-next-icon" aria-hidden="true"></span>
					<span class="visually-hidden">Next</span>
					</button>
				</div>

			</Container>
			
			<Container className="py-3 container-styling">
				<h2 class="text-center py-1">Fun Facts</h2>
				<ol>
					<li>If you're wondering what all the BUZZ is about, we met after both getting stung in the Bumble BeeHive .</li>
					<li>Our first date was on February 15th, 2018, in The Mailbox Birmingham. Because nothing says romance like narrowly missing Valentine's Day!</li>
					<li>We moved to London just before the pandemic hit. Our timing is impeccable, as always.</li>
					<li>Nathan proposed on a "belated birthday trip" to Canterbury. To this day, Rebecca's response remains a mystery (we're still waiting for the answer!).</li>
					<li>By May 2025, we'll have been together for 7 years. Time flies when you're having fun!</li>
            	</ol>
            </Container>
		</div>
	);
};

export default About;
